import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { AnnouncementBar } from '@/components/layout/AnnouncementBar';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { Welcome } from '@/components/sections/Welcome';
import { Services } from '@/components/sections/Services';
import { Mission } from '@/components/sections/Mission';
import { Video } from '@/components/sections/Video';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        
        {/* Open Graph Tags */}
        <meta property="og:site_name" content={siteData.title} />
        <meta property="og:title" content={siteData.title} />
        <meta property="og:url" content="https://www.conservatoryofmusicalarts.com" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={siteData.description} />
        <meta property="og:image" content="https://images.squarespace-cdn.com/content/v1/5c7459e294d71afc38ad68b4/4004df77-de06-4741-8b58-6375f2f7ea42/WebLogoCropped.png?format=1500w" />
        <meta property="og:image:width" content="1449" />
        <meta property="og:image:height" content="576" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:title" content={siteData.title} />
        <meta name="twitter:image" content="https://images.squarespace-cdn.com/content/v1/5c7459e294d71afc38ad68b4/4004df77-de06-4741-8b58-6375f2f7ea42/WebLogoCropped.png?format=1500w" />
        <meta name="twitter:url" content="https://www.conservatoryofmusicalarts.com" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:description" content={siteData.description} />
        
        {/* Schema.org Microdata */}
        <meta itemProp="name" content={siteData.title} />
        <meta itemProp="url" content="https://www.conservatoryofmusicalarts.com" />
        <meta itemProp="description" content={siteData.description} />
        <meta itemProp="thumbnailUrl" content="https://images.squarespace-cdn.com/content/v1/5c7459e294d71afc38ad68b4/4004df77-de06-4741-8b58-6375f2f7ea42/WebLogoCropped.png?format=1500w" />
        <meta itemProp="image" content="https://images.squarespace-cdn.com/content/v1/5c7459e294d71afc38ad68b4/4004df77-de06-4741-8b58-6375f2f7ea42/WebLogoCropped.png?format=1500w" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://www.conservatoryofmusicalarts.com" />
        
        {/* Schema.org JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "WebSite",
            "url": "https://www.conservatoryofmusicalarts.com",
            "name": siteData.title,
            "description": siteData.description,
            "image": "https://images.squarespace-cdn.com/content/v1/5c7459e294d71afc38ad68b4/4004df77-de06-4741-8b58-6375f2f7ea42/WebLogoCropped.png"
          })}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Organization",
            "legalName": siteData.title,
            "address": siteData.contact.address,
            "email": siteData.contact.email,
            "telephone": siteData.contact.phone,
            "sameAs": [
              siteData.socialMedia.instagram,
              siteData.socialMedia.facebook
            ]
          })}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            "address": siteData.contact.address,
            "image": "https://images.squarespace-cdn.com/content/v1/5c7459e294d71afc38ad68b4/4004df77-de06-4741-8b58-6375f2f7ea42/WebLogoCropped.png",
            "name": siteData.title,
            "openingHours": "Mo 12:00-18:00, Tu 12:00-18:00, We 12:00-18:00, Th 12:00-18:00, Fr 12:00-16:00, Sa 22:00-17:00"
          })}
        </script>
      </Helmet>
      
      <div className="min-h-screen bg-gray-50">
        <AnnouncementBar />
        <Header />
        
        {/* Hero Section */}
        <Hero />
        
        {/* Welcome Section */}
        <Welcome />
        
        {/* Services Section */}
        <Services />
        
        {/* Mission Section */}
        <Mission />
        
        {/* Video Section */}
        <Video />
        
        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}